<template lang="html">
  <my360FormGroup>
    <label
      v-if="label"
      :for="prop">
      {{ label }}
    </label>
    <textarea
      v-model="propPath"
      v-bind="attributes"
      :validationName="validationName"
      :prop="prop"
      :name="attributes.name ? attributes.name : prop"
      :class="classNames"
      style="background: white; width: 100%"/>
    <div
      v-if="hasKey(errorBag, prop)"
      class="invalid-feedback">
      <i class="far fa-times-circle" />
      {{ getErrorMessage }}
    </div>
  </my360FormGroup>
</template>
<script>
import inputType from '../../mixins/inputType'

export default {
  name: 'My360Textarea',

  mixins: [inputType],

  computed: {
    defaultAttributes () {
      return {
        rows: 4
      }
    }
  }
}
</script>
